import * as fetch from '@hydra/utils/fetcher';

export async function addCompetitors (competitors, projectUrl) {
  return fetch.put('/api/settings/competitors', {
    json: { competitors, projectUrl }
  }).json();
}

export async function updateNotifications (notifications, projectUrl) {
  return fetch.put('/api/settings/notifications', {
    json: { notifications, projectUrl }
  }).json();
}

export async function getProjectViews (url) {
  return fetch.get(`/api/settings/project-views/${encodeURIComponent(url)}`).json();
}

export async function setDefaultProjectView (url, viewId) {
  return fetch.put(`/api/settings/project-views/${encodeURIComponent(url)}/${viewId}`).json();
}

export async function deleteProjectView (url, viewId) {
  return fetch.del(`/api/settings/project-views/${encodeURIComponent(url)}/${viewId}`).json();
}

export async function createProjectView (url, name, value) {
  return fetch.post('/api/settings/project-views', {
    json: { url, name, value }
  }).json();
}
